import DefaultCostEstimateDigital from "src/components/feature/CostEstimateDigital";

const CostEstimateDigital = () => {
  return <DefaultCostEstimateDigital />;
};

export default CostEstimateDigital;
